export default __webpack_public_path__ + "static/media/poppins-bold.7d11a834.ttf";